import React from 'react';
import { ContactBookResult } from '@/services/api/contacts';
import { ContactBookItem } from './ContactBookItem';
import { Loader2, Search } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ContactBookDropdownProps {
  contacts: ContactBookResult[];
  loading: boolean;
  error: string | null;
  onContactSelect: (contact: ContactBookResult, phone?: string, email?: string) => void;
  mode?: 'dialer' | 'email';
  show: boolean;
  searchQuery: string;
  className?: string;
}

export const ContactBookDropdown = ({
  contacts,
  loading,
  error,
  onContactSelect,
  mode = 'dialer',
  show,
  searchQuery,
  className
}: ContactBookDropdownProps) => {
  if (!show || (!loading && !error && contacts.length === 0 && !searchQuery.trim())) {
    return null;
  }

  return (
    <div className={cn(
      "absolute top-full left-0 right-0 mt-1 bg-background border border-border rounded-md shadow-lg z-50 max-h-64 overflow-y-auto",
      className
    )}>
      {loading && (
        <div className="flex items-center justify-center p-4">
          <Loader2 className="h-4 w-4 animate-spin mr-2" />
          <span className="text-sm text-muted-foreground">Searching...</span>
        </div>
      )}

      {error && (
        <div className="p-4 text-center">
          <div className="text-sm text-destructive">{error}</div>
        </div>
      )}

      {!loading && !error && contacts.length === 0 && searchQuery.trim() && (
        <div className="flex flex-col items-center justify-center p-4 text-center">
          <Search className="h-8 w-8 text-muted-foreground/50 mb-2" />
          <div className="text-sm text-muted-foreground">No contacts found</div>
          <div className="text-xs text-muted-foreground/70 mt-1">
            Try searching by {mode === 'dialer' ? 'phone number' : 'email address'}
          </div>
        </div>
      )}

      {!loading && !error && contacts.length > 0 && (
        <div className="py-1">
          {contacts.map((contact) => (
            <ContactBookItem
              key={contact.contact_id}
              contact={contact}
              onClick={onContactSelect}
              mode={mode}
            />
          ))}
        </div>
      )}
    </div>
  );
};